window.mcb = window.mcb || {};
window.mcb.header = window.mcb.header || {};
window.mcb.header.resizeTimeout = undefined;
window.mcb.header.resizeMatchingSecondidthsObserver = new ResizeObserver(entries => {
    if (window.mcb.header.resizeTimeout) {
        clearTimeout(window.mcb.header.resizeTimeout);
    }

    window.mcb.header.resizeTimeout = setTimeout(() => {
        for (let entry of entries) {
            let leftWidth = 0;
            let rightWidth = 0;

            let matchWidth = entry.target.querySelectorAll('.mcb-page-header_ribbon--second .mcb-match-width');

            if (matchWidth) {
                let left = matchWidth[0].children[0];
                const leftRect = left?.getBoundingClientRect();
                leftWidth = leftRect?.width;

                let right = matchWidth[1].children[0];
                const rightRect = right?.getBoundingClientRect();
                rightWidth = rightRect?.width ?? 0;
            }

            let x1 = 0;
            let x2 = 0;
            let linksSecondLevel = entry.target.querySelectorAll('.mcb-page-header_ribbon--second ul.mcb-header--nav-links.mcb-header--nav-links--second-level')
            linksSecondLevel.forEach((match) => {
                const rect = match.getBoundingClientRect();
                x1 = rect.x;
                x2 = x1 + rect.width;
            });

            let padding = 24;
            let leftX = leftWidth + padding;
            let rightX = window.innerWidth - (rightWidth + padding);

            let space = 50;

            let toBig = linksSecondLevel.length != 0 && (leftX + space > x1 || rightX - space < x2)

            if (toBig) {
                let second = document.querySelector("#mcb-page-header .mcb-page-header_ribbon--second");
                if (!second.classList.contains("big")) {
                    second.classList.add("big")
                }
            } else {
                let second = document.querySelector("#mcb-page-header .mcb-page-header_ribbon--second");
                if (second.classList.contains("big")) {
                    second.classList.remove("big")
                }
            }
        }
    }, 10);
});

window.mcb.header.setNavigationScrollState = function (_direction) {
    const topElement = document.querySelector(".mcb-page-header_ribbon--first");
    const bottomElement = document.querySelector(".mcb-page-header_ribbon--second");

    if (_direction === 'down') {
        bottomElement.style.setProperty('--mcb-header-transform', `translateY(${-topElement.clientHeight}px)`);
    }
    else {
        bottomElement.style.setProperty('--mcb-header-transform', 'translateY(0)');
    }
};

$(function () {
    if (!!document.querySelector(".mcb-page-header_ribbon--second.mcb-match-widths")) {
        window.mcb.header.resizeMatchingSecondidthsObserver.observe(document.querySelector(".mcb-page-header_ribbon--second.mcb-match-widths"));
    }

    let _headertop = $(window).scrollTop();
    $(window).scroll(function () {
        let _cur_top = $(window).scrollTop();
        let _direction;
        if (_headertop < _cur_top) {
            _direction = 'down';
        }
        else {
            _direction = 'up';
        }

        if (document.querySelector('body').classList.contains('mcp-programmatically-scrolling')) {
            _headertop = $(window).scrollTop();
        }
        else {
            window.mcb.header.setNavigationScrollState(_direction);
        }

        _headertop = _cur_top;

        window.lastScrollDirection = _direction;
    });

    //_logger.log(`isMobileDevice: ${window.mcb.utilities.browser.isMobileDevice()}, isTabletDevice: ${window.mcb.utilities.browser.isTabletDevice()}, navigator.userAgentData.platform: ${navigator.userAgentData.platform}`)

    //Fly-out functionality and Hover effekt
    let timerMenuItems;
    let menuItems = document.querySelectorAll('#desktop .level-3-box, #desktop a.mcb-header--link--third-level');
    Array.prototype.forEach.call(menuItems, (el, i) => {
        el.addEventListener("mouseover", function (event) {
            // check 'hover' class to the current elements
            let hasHover = $(this.parentElement.querySelector("#desktop .mcb-header--link--third-level")).hasClass("hover");

            // try to make level-3-box the same with as link--third-level 
            let link = $(this.parentElement.querySelector("#desktop .mcb-header--link--third-level"));
            let width = link.width()
            let parent = link.parent()[0];
            let box = parent.querySelector(".mcb-header--nav-links--third-sub-level");
            let padding = window.getComputedStyle(box).getPropertyValue('--mcb-header--third-level--img-padding');
            box = box.style.width = `calc(${width}px + ${padding})`;

            // Make sure all others menu's is close 
            $(this.parentElement.parentElement.querySelector("#desktop .mcb-header--link--third-level.mouseover")).removeClass("mouseover");
            $(this.parentElement.parentElement.querySelector("#desktop .mcb-header--link--third-level.hover")).removeClass("hover");
            $(this.parentElement.parentElement.querySelector("#desktop .level-3-box.hover")).removeClass("hover");

            // Add hover class to the menu 
            $(this.parentElement.querySelector("#desktop .level-3-box")).addClass('hover');
            $(this.parentElement.querySelector("#desktop .mcb-header--link--third-level")).addClass('hover');

            //add a extra class 'mouseover' (it will be remove in the click event)
            if (!hasHover && (window.mcb.utilities.browser.isMobileDevice() || window.mcb.utilities.browser.isTabletDevice())) {
                $(this.parentElement.querySelector("#desktop .mcb-header--link--third-level")).addClass('mouseover');
            }

            //Reset timerMenuItems's Timeout
            clearTimeout(timerMenuItems);
        });
        el.addEventListener("mouseout", (event) => {
            //Remove the hover after 1000 ms
            timerMenuItems = setTimeout((event) => {
                let box = $("#desktop .level-3-box.hover");
                box.removeClass('hover');
                let link = $("#desktop .mcb-header--link--third-level.hover");
                link.removeClass('hover');
                link.removeClass('mouseover');
            }, 1000);
        });

        el.addEventListener("click", (event) => {
            let target = $(event.target);
            let link = target.parent().children(".mcb-header--link--third-level");
            let box = target.parent().children(".level-3-box");

            if (window.mcb.utilities.browser.isMobileDevice() || window.mcb.utilities.browser.isTabletDevice()) {
                // check if link has the 'mouseover' 
                if (!link.hasClass("mouseover")) {
                    if (link.hasClass("hover")) {
                        link.removeClass('hover');
                        box.removeClass('hover');
                    } else {
                        link.addClass('hover');
                        box.addClass('hover');
                    }
                } else {
                    link.removeClass('mouseover');
                }
            }

            event.stopPropagation();
        })
    });
});

window.HeaderOpenSideBar = () => {
    let sideBar = document.querySelector(".mcb-page-header-mobile-sidebar");
    let grayBox = document.querySelector("#header-gray-box");
    let body = document.querySelector("body");

    if (!!sideBar) {
        if (!sideBar.classList.contains("open")) {
            sideBar.classList.add("open")
        }
    }

    if (!!body) {
        if (!body.classList.contains("mobile-menu-open")) {
            body.classList.add("mobile-menu-open")
        }
    }

    if (!!grayBox) {
        if (!grayBox.classList.contains("show")) {
            grayBox.classList.add("show")
        }
    }
};

window.HeaderCloseSideBar = () => {
    let sideBar = document.querySelector(".mcb-page-header-mobile-sidebar");
    let grayBox = document.querySelector("#header-gray-box");
    let body = document.querySelector("body");

    if (!!sideBar) {
        if (sideBar.classList.contains("open")) {
            sideBar.classList.remove("open")
        }
    }

    if (!!body) {
        if (body.classList.contains("mobile-menu-open")) {
            body.classList.remove("mobile-menu-open")
        }
    }

    if (!!grayBox) {
        if (grayBox.classList.contains("show")) {
            grayBox.classList.add("in-change")
            grayBox.classList.remove("show")

            setTimeout(function () {
                grayBox.classList.remove("in-change")
            }, 200);
        }
    }
};
